import React, { useState, useEffect } from "react";
import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Link from "@material-ui/core/Link";
import Grid from "@material-ui/core/Grid";
import { useHistory } from "react-router-dom";
import FormErrors from "../validation/FormErrors";
import Validate from "../validation/FormValidation";
import { Auth } from "aws-amplify";
import "./forgotPassword.scss";
import { useTranslation } from 'react-multi-lang'
import { withStyles } from '@material-ui/core/styles';

const CssTextField = withStyles({
  root: {
    '& label.Mui-focused': {
      color: '#c7d100',
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: '#c7d100',
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        // borderColor: '#c7d100',
      },
      '&:hover fieldset': {
        borderColor: '#c7d100',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#c7d100',
      },
    },
  },
})(TextField);



export default function ForgotPassword(props: { auth: { setAuthStatus: (arg0: boolean) => void; setUser: (arg0: any) => void; }; history: string[]; location: any}) {
  const history = useHistory();
  const [state, setState] = useState({
    username: "",
    errors: {
      cognito: {},
      blankfield: false
    }
  })

//   useEffect(() => {
//     Auth.signOut();
//     dispatch(Vanish());
//     if(props.location.search){
//       const str = props.location.search.replaceAll("?", "");  
//       dispatch(SetLanguage(str))
//     }
//   }, [])


  const clearErrorState = () => {
    setState({
      ...state, errors: {
        cognito: {},
        blankfield: false
      }
    })
  };

  const onInputChange = async (event: { target: { name: any; value: any; }; }) => {

    const { name, value } = event.target
    await setState({ ...state, [name]: value })

    //document.getElementById(event.target.id).classList.remove("is-danger");
  };

  const redirectLogin = () => {
    history.push("/");
  };

  const handleSubmit = async (event: { preventDefault: () => void; }) => {
    event.preventDefault();

    // Form validation
    clearErrorState();
    const error = Validate(event, state);
    if (error) {
      setState({ ...state, ...error });
    }

    if (state.username === "") {
      let err = {code: "InvalidParameterException", name: "InvalidParameterException", message: t("Please enter a username")};
      setState({ ...state, errors: { cognito: err, blankfield: false } });
    }
    else {
      // AWS Cognito integration here
      try {
        const user = await Auth.forgotPassword(state.username);
        history.push("/resetPassword");
      } catch (error) {
        let err = null;
        !error.message ? (err = { message: error }) : (err = error);
        setState({ ...state, errors: { cognito: err, blankfield: false } });
      }
    }
  };
  const t = useTranslation()

  return (
    <section className="section">
      <div className="container fpContainer">
        <div className="avtarDiv">
          <Avatar></Avatar>
        </div>
        <div className="fpHeader">{t('Forgot Password')}</div>

        <form
          onSubmit={handleSubmit}
          className="fpForm"
          noValidate
          autoComplete="off"
        >
          <div className="fpFormMargin">
            <div>
              <CssTextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                defaultValue={state.username}
                onChange={onInputChange}
                id="username"
                label={t('Username')}
                name="username"
              // autoComplete="username"
              />
            </div>
            <div className="errorMsg">
              <FormErrors formerrors={state.errors} />
            </div>
            <div className="fpBtn">
              <Button
                type="button"
                fullWidth
                variant="outlined"
                onClick={handleSubmit}
              >
                {t("Get Code")}
              </Button>
            </div>
            <Grid className="fpRouteLink" container>
            <Grid item xs>
            </Grid>
            <Grid item>
              <Link
                // href="javascript:void(0)"
                onClick={() => {
                  redirectLogin();
                }}
                variant="body2"
              >
                {t("Sign In")}
              </Link>
            </Grid>
          </Grid>
          </div>
        </form>
      </div>
    </section>
  );
}
